
import './styles/quasar.scss'
import iconSet from 'quasar/icon-set/fontawesome-v6.js'
import lang from 'quasar/lang/zh-TW.js'
// import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';import Notify from 'quasar/src/plugins/Notify.js';import Cookies from 'quasar/src/plugins/Cookies.js';import Screen from 'quasar/src/plugins/Screen.js';import Loading from 'quasar/src/plugins/Loading.js';import LoadingBar from 'quasar/src/plugins/LoadingBar.js';import Dialog from 'quasar/src/plugins/Dialog.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
    AppFullscreen,
    Notify,
    Cookies,
    Screen,
    Loading,
    // LoadingBar,
    Dialog,
    LocalStorage,
  },
  lang: lang,
  iconSet: iconSet,
}